<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_IS_PRODUCTION_INDUSTRIAL'
        )
      }"
    >
      <select
        :disabled="$parent.$parent.projectDisabled"
        v-model="project.UF_IS_PRODUCTION_INDUSTRIAL"
        class="sel-dropdown i-main-style i-wid-13"
      >
        <option :value="1">Да</option>
        <option :value="2">Будет получено в ходе реализации проекта</option>
        <option :value="0">Нет</option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_IS_PRODUCTION_INDUSTRIAL"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "uf_is_production-industrial",
  computed: {
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
